<!-- Conditions générales d'utilisation, acceptées à l'inscription (case de Register.vue).
     Les champs .todo-placeholder sont à remplir par l'association. -->
<template>
  <div>
    <Navbar />
    <div class="legal-page">
      <el-card shadow="always" class="legal-card">
        <template #header>
          <h1>Conditions générales d'utilisation</h1>
          <p class="legal-updated">Dernière mise à jour : 1er novembre 2026</p>
        </template>

        <h2>1. Objet</h2>
        <p>
          Les présentes conditions encadrent l'utilisation de Wedoomotion, réseau social associatif édité par
          <span class="todo-placeholder">[À COMPLÉTER : nom de l'association]</span>
          (voir les <router-link to="/mentions-legales">mentions légales</router-link>).
          L'inscription vaut acceptation des présentes conditions et de la
          <router-link to="/confidentialite">politique de confidentialité</router-link>.
        </p>

        <h2>2. Inscription</h2>
        <p>
          L'inscription est gratuite. Vous fournissez une adresse e-mail valide et choisissez un nom d'utilisateur
          et un mot de passe, que vous gardez confidentiel. Le compte est activé par le code reçu par e-mail ;
          un compte non validé est supprimé automatiquement. Un seul compte par personne.
          <span class="todo-placeholder">[À COMPLÉTER : âge minimum ou accord parental]</span>
        </p>

        <h2>3. Règles de conduite</h2>
        <p>En publiant sur Wedoomotion, vous vous engagez à ne pas diffuser de contenu :</p>
        <ul>
          <li>injurieux, diffamatoire, harcelant, discriminatoire ou incitant à la haine ou à la violence ;</li>
          <li>pornographique, ou mettant en danger des mineurs ;</li>
          <li>portant atteinte à la vie privée ou à l'image d'autrui, ou aux droits d'auteur ;</li>
          <li>publicitaire, frauduleux ou contraire à la loi.</li>
        </ul>
        <p>Vous restez seul responsable des contenus que vous publiez.</p>

        <h2>4. Publication et modération</h2>
        <p>
          Les publications sont mises en ligne sans validation préalable. Chaque membre peut signaler une publication,
          un commentaire ou un profil avec le bouton « Signaler », en choisissant le motif (harcèlement, propos haineux,
          contenu illicite…) et en ajoutant s'il le souhaite des précisions. Les administrateurs et modérateurs
          examinent les signalements et peuvent supprimer tout contenu contraire aux présentes conditions.
        </p>

        <h2>5. Vos contenus</h2>
        <p>
          Vous conservez vos droits sur vos contenus. Vous autorisez Wedoomotion à les afficher aux autres membres,
          pour la seule durée de leur présence sur le site. Vous pouvez supprimer vos publications à tout moment.
        </p>

        <h2>6. Suspension et suppression du compte</h2>
        <p>
          Vous pouvez supprimer votre compte à tout moment depuis votre profil. En cas de manquement grave ou répété
          aux présentes conditions, un administrateur peut supprimer votre compte.
        </p>

        <h2>7. Conservation des données d'identification</h2>
        <p>
          En tant qu'hébergeur des contenus publiés par ses membres, l'association est tenue par la loi
          (article 6 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique et
          décret n° 2021-1362 du 20 octobre 2021) de conserver les données permettant d'identifier l'auteur d'un contenu.
          À chaque connexion, Wedoomotion enregistre votre nom d'utilisateur, votre adresse e-mail, votre adresse IP
          ainsi que la date et l'heure de début et de fin de connexion.
        </p>
        <p>
          Ces données sont conservées un an à compter de chaque connexion, puis effacées automatiquement. Si vous
          supprimez votre compte, votre nom d'utilisateur et votre adresse e-mail, ainsi que leur lien avec vos
          commentaires restés en ligne, sont conservés un an à compter de la suppression. Elles ne sont ni visibles des autres membres, ni utilisées à d'autres fins : elles ne peuvent
          être communiquées qu'aux autorités judiciaires ou administratives qui en font la demande dans le cadre prévu
          par la loi. Voir la <router-link to="/confidentialite">politique de confidentialité</router-link>.
        </p>

        <h2>8. Responsabilité</h2>
        <p>
          L'association s'efforce d'assurer la disponibilité du service, sans pouvoir la garantir. Elle n'est pas
          responsable des contenus publiés par les membres, mais les retire promptement dès qu'elle a connaissance
          de leur caractère illicite.
        </p>

        <h2>9. Modification des conditions</h2>
        <p>
          Les présentes conditions peuvent évoluer. La date de dernière mise à jour figure en haut de cette page ;
          en cas de changement important, les membres en sont informés.
        </p>

        <h2>10. Droit applicable</h2>
        <p>
          Les présentes conditions sont soumises au droit français. En cas de litige, une solution amiable est
          recherchée avant toute action devant les tribunaux compétents.
          Contact : <span class="todo-placeholder">[À COMPLÉTER : contact@domaine]</span>.
        </p>

        <nav class="legal-links">
          <router-link to="/mentions-legales">Mentions légales</router-link>
          <router-link to="/confidentialite">Politique de confidentialité</router-link>
        </nav>
      </el-card>
    </div>
  </div>
</template>

<script>
import '@/styles/legal.css'
import Navbar from '@/components/Navbar.vue'

export default {
  name: 'TermsOfUse',
  components: {
    Navbar,
  },

  mounted() {
    document.body.style.backgroundColor = 'rgba(21, 109, 123)'
  },
}
</script>
